import React from 'react';
import { Hero } from './Hero';
import { StickyCTABar } from './StickyCTABar';
import { PurchaseNotification } from './PurchaseNotification';
import { MetricsBar } from './MetricsBar';
import { ShiftSection } from './ShiftSection';
import { ScenesSection } from './ScenesSection';
import { WhatsInsideSection } from './WhatsInsideSection';
import { ProductPreview } from './ProductPreview';
import { DeliverySection } from './DeliverySection';
import { SevenDayPlan } from './SevenDayPlan';
import { BonusSection } from './BonusSection';
import { OfferSection } from './OfferSection';
import { GuaranteeSection } from './GuaranteeSection';
import { TestimonialsSection } from './TestimonialsSection';
import { WhyExistsSection } from './WhyExistsSection';
import { FAQSection } from './FAQSection';
import { FinalCTA } from './FinalCTA';
import { FooterSection } from './FooterSection';
export function LandingPage() {
  return <div className="w-full bg-cream text-ink selection:bg-gold/25" data-id="element-86" data-mp="1ysb0g8t5s9s">
      <main data-id="element-87" data-mp="2nigxdc408w8d">
        <Hero data-id="element-88" data-mp="2nhozfumxqmex" />
        <MetricsBar data-id="element-89" data-mp="2nh5rn6r01eem" />
        <ShiftSection data-id="element-90" data-mp="2ngnqpwte6c0d" />
        <ScenesSection data-id="element-91" data-mp="2ngdx7z951mpx" />
        <WhatsInsideSection data-id="element-92" data-mp="2s8nl79qp0cpk" />
        <ProductPreview data-id="element-93" data-mp="2s9yufp2wqco2" />
        <DeliverySection data-id="element-94" data-mp="2sa8dsttg5lks" />
        <SevenDayPlan data-id="element-95" data-mp="2ehirspdx4gno" />
        <BonusSection data-id="element-96" data-mp="2ei26lx89uoxh" />
        <OfferSection data-id="element-97" data-mp="2eits2f85n6a1" />
        <GuaranteeSection data-id="element-98" data-mp="2ejd97tpzdqn0" />
        <TestimonialsSection data-id="element-99" data-mp="2ij41k1v5oetn" />
        <WhyExistsSection data-id="element-100" data-mp="2ik5mqz5vyhp3" />
        <FAQSection data-id="element-101" data-mp="2ijnk9ksmr78q" />
        <FinalCTA data-id="element-102" data-mp="2igrifldnvyf0" />
      </main>
      <FooterSection data-id="element-103" data-mp="3686rry3uvfzr" />
      <div className="h-[66px] bg-carbon" aria-hidden="true" data-id="element-104" data-mp="369ri1bj50crt" />
      <StickyCTABar data-id="element-105" data-mp="3b7jcodb62czp" />
      <PurchaseNotification data-id="element-106" data-mp="3b81hhybw9zj8" />
    </div>;
}